import babbelTracker from '@lessonnine/tracker.js';
import appConfig from 'src/utils/appConfig';
import externalRouter from 'src/utils/externalRouter';
import { reportTrackerFailure } from 'src/utils/rollbar';

/* PPF Tracker is an interface for tracker-babbel.*/

let _babbelTracker = null;

const getTrackerOptions = () => {
  let trackerOptions = {
    url: externalRouter.parse('eventTracker'),
    trackingUuidName: 'babbeltrackinguuid',
    defaultPayload: () => {
      return {
        locale: appConfig.getMyConfig().locale,
        learn_language_alpha3: appConfig.getLearningLanguage(),
        provider: 'ppf.spa'
      };
    }
  };

  const { osName, browserName } = appConfig.getMyConfig().client;
  const disableBeacon = osName === 'iOS' && browserName !== 'Safari';

  return Object.assign({}, trackerOptions, { disableBeacon });
};

const initialize = () => {
  _babbelTracker = new babbelTracker.Tracker(getTrackerOptions());
};

const trackBabbelTracker = (eventName, version, payload) => {
  if (!_babbelTracker) initialize();

  const error = (error) => reportTrackerFailure(error, eventName, payload);
  _babbelTracker.track({ name: eventName, version, payload, error });
};

export default {
  trackBabbelTracker
};
